export const trackBingEvent = (eventName: string, meta?: Record<string, string | number>) => {
  window.uetq = window.uetq || [];
  window?.uetq?.push('event', eventName, meta);
};
